import { render } from "./PriceAmount.vue?vue&type=template&id=11665013&scoped=true"
import script from "./PriceAmount.vue?vue&type=script&lang=js"
export * from "./PriceAmount.vue?vue&type=script&lang=js"

import "./PriceAmount.vue?vue&type=style&index=0&id=11665013&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11665013"]])

export default __exports__